import { optionTitle_calendarSurfaceAddins } from './CalendarSurfaceAddinsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let CalendarSurfaceAddinsOption: LazyOption = createLazyOption(
    {
        key: 'calendarSurfaceAddins',
        titleStringKey: optionTitle_calendarSurfaceAddins,
        searchTermsStringKey: optionTitle_calendarSurfaceAddins,
        isHidden: () => !isFeatureEnabled('cal-addins'),
    },
    lazyFullModule,
    m => m.default
);
export default CalendarSurfaceAddinsOption;
